import { type FunctionComponent, type HTMLAttributes, useEffect } from 'react';
import useScript from 'react-script-hook';
import { buildGTMQALoaded } from '../../../helpers/analytics/gtm/product-event-builders';
import { generateScriptURL } from '../../../helpers/product-helper/reviews-qa.helper';
import { useTrackEvent } from '../../../hooks/analytics/analytics.hooks';

export type ProductQuestionsAndAnswersProps = {
	id: number;
} & Pick<HTMLAttributes<HTMLElement>, 'className'>;

/**
 * Product Questions & Answers Component
 *
 * @param {ProductQuestionsAndAnswersProps} props
 * @returns ReactNode
 */
export const ProductQuestionsAndAnswers: FunctionComponent<ProductQuestionsAndAnswersProps> = ({ className = 'ph3 pb5', id }) => {
	const trackEvent = useTrackEvent();

	useScript({
		src: generateScriptURL(),
		checkForExisting: true
	});

	useEffect(() => {
		trackEvent(buildGTMQALoaded());
	}, []);

	return (
		<div className={className}>
			<div data-bv-show="questions" data-bv-product-id={`cp-${id}`} data-testid="bazaar-container" />
		</div>
	);
};
